import React, { Component } from "react";
import DialogContent from "@material-ui/core/DialogContent";
import CardHeader from "@material-ui/core/CardHeader";
import KpsEditor from "../editor/KpsEditor";

class DecisionNode extends Component {
  render() {
    return (
      <div>
        <CardHeader title={this.props.node.label} id="node-label" />{" "}
        <DialogContent>
          <KpsEditor initialContent={this.props.node.notes} readOnly />
        </DialogContent>
      </div>
    );
  }
}
export default DecisionNode;
